import React, { useEffect, useState } from "react";
import { supabase } from "../supabase";
import GoToTop from "../GoToTop";

function Gallery() {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const { data, error } = await supabase
        .from("gallery")
        .select("id, title, description, url")
        .order("created_at", { ascending: false });

      if (error) throw error;

      setGallery(data || []);
    } catch (err) {
      console.error("Error fetching gallery:", err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <GoToTop />
      <section id="portfolio" className="portfolio section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Gallery</h2>
          <p>Check Our Portfolio</p>
        </div>

        <div className="container">
          <div
            className="isotope-layout"
            data-default-filter="*"
            data-layout="masonry"
            data-sort="original-order"
          >
            <div
              className="row gy-4 portfolio-container isotope-container"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {loading ? (
                <p className="text-center">Loading gallery...</p>
              ) : gallery.length === 0 ? (
                <p>No images found.</p>
              ) : (
                <>
                  {gallery.map((item) => (
                    <>
                      <div className="col-lg-4 col-md-6 portfolio-item isotope-item">
                        <div className="portfolio-wrap">
                          <img
                            src={item.url}
                            alt={item.title}
                            className="img-fluid"
                            loading="lazy"
                          />
                          <div className="portfolio-info">
                            {item.title && <p>{item.title}</p>}
                            {/* <div className="portfolio-links">
                            <a
                              href={a}
                              className="glightbox"
                              title="Capturing Moments"
                            >
                              <i className="bi bi-zoom-in"></i>
                            </a>
                            <a
                              href="portfolio-details.html"
                              title="More Details"
                            >
                              <i className="bi bi-link-45deg"></i>
                            </a>
                          </div> */}
                          </div>
                        </div>
                      </div>
                    </>
                  ))}
                </>
              )}
            </div>
            {/* <!-- End Portfolio Container --> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default Gallery;
